import React from 'react';
import Nutzungsinfos from '../general/Nutzungsinfos';

const ForbiddenState = ({ isEligable, isLoggedIn, availableUses, usageCount, has }) => {
  return <div>
    <p style={{ color: 'white' }}>Du darfst keine weiteren Anpassungen mehr machen!</p>
    <p style={{ color: 'white' }}>Hier ist dein letztes</p>
    {/* <Nutzungsinfos isEligable={isEligable} isLoggedIn={isLoggedIn} availableUses={availableUses} usageCount={usageCount} /> */}
  </div>;
};

export default ForbiddenState;
